import React, { Component } from "react";
import AntDSelectWrapper from "../../../../Components/CustomWrappers/AntDSelectWrapper";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import { AN13ENRValidator } from "../../../Registration/RegistrationFormView/validators";

export class CustomerCodeRequest extends Component {
  render() {
    const {
      disabled,
      formRef,
      validate_employee_code,
      salesGroupData,
      handleChange,
    } = this.props;
    return (
      <div className="row form-box">
        <legend className="form-legend">Customer Code Request Form</legend>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="client_id"
            id="client_id"
            required={false}
            disabled={true}
            label="Client ID"
            message="Enter Client ID"
            placeholder="Enter Client ID"
            validators=""
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="type_of_customer"
            id="type_of_customer"
            required={true}
            disabled={true}
            label="Type of Customer"
            message="Select Type of Customer"
            placeholder="Select Type of Customer"
            validators=""
            app="masters"
            entity="typeofcustomer"
            options={[]}
            primary_key_field="id"
            prefixId={true}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="acc_assignment_group"
            id="acc_assignment_group"
            required={false}
            disabled={disabled}
            label="Account Assignment Group"
            message="Select Account Group"
            placeholder="Select Account Group"
            validators=""
            app="masters"
            entity="accountassignmentgroup"
            options={[]}
            primary_key_field="id"
            prefixId={true}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="sales_district"
            id="sales_district"
            required={true}
            disabled={disabled}
            label="Sales District"
            message="Select Sales District"
            placeholder="Select Sales District"
            validators=""
            app="masters"
            entity="salesdistrict"
            options={[]}
            primary_key_field="sales_district_id"
            prefixId={true}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="customer_status_group"
            id="customer_status_group"
            required={false}
            disabled={disabled}
            label="Customer Statistics Group"
            message="Select Statistics Group"
            placeholder="Select Statistics Group"
            validators=""
            app="masters"
            entity="customerstatsgroup"
            options={[]}
            primary_key_field="stats_group_id"
            prefixId={true}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="sales_office"
            id="sales_office"
            required={false}
            disabled={disabled}
            label="Sales Office"
            message="Select Sales Office"
            placeholder="Select Sales Office"
            validators=""
            app="masters"
            entity="salesoffice"
            options={[]}
            onChange={handleChange}
            primary_key_field="sales_office_id"
            prefixId={true}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="sales_group"
            id="sales_group"
            required={false}
            disabled={disabled}
            label="Sales Group"
            message="Select Sales Group"
            placeholder="Select Sales Group"
            validators=""
            options={salesGroupData}
            primary_key_field="sales_group_id"
            prefixId={true}
            formRef={formRef}
          />
        </div>

        {/* <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="customer_code_series"
            id="customer_code_series"
            required={true}
            disabled={disabled}
            label="Customer Code Series"
            message="Select Customer Code Series"
            placeholder="Select Customer Code Series"
            validators=""
            app="masters"
            entity="customercodeseries"
            options={[]}
            primary_key_field="series_id"
            formRef={formRef}
          />
        </div> */}

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="business_vertical"
            id="business_vertical"
            required={false}
            disabled={disabled}
            label="Business Vertical"
            message="Select Business Vertical"
            placeholder="Select Business Vertical"
            validators=""
            app="masters"
            entity="businessvertical"
            options={[]}
            primary_key_field="business_vertical_id"
            prefixId={true}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="external_number_range"
            id="external_number_range"
            required={true}
            disabled={disabled}
            label="Employee Code"
            message="Enter Employee Code"
            placeholder="Enter Employee Code"
            onChangeText={validate_employee_code}
            validators={[{ validator: AN13ENRValidator }]}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="shipping"
            id="shipping"
            required={false}
            disabled={disabled}
            label="Shipping Condition"
            message="Select Shipping Condition"
            placeholder="Select Shipping Condition"
            validators=""
            app="masters"
            entity="shippingcondition"
            options={[]}
            primary_key_field="shipping_condition_id"
            prefixId={true}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="division"
            id="division"
            required={true}
            disabled={true}
            label="Division"
            message="Select Division"
            placeholder="Select Division"
            validators=""
            app="masters"
            entity="division"
            options={[]}
            primary_key_field="division_id"
            prefixId={true}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="distribution_channel"
            id="distribution_channel"
            required={true}
            disabled={true}
            label="Distribution Channel"
            message="Select Distribution Channel"
            placeholder="Select Distribution Channel"
            validators=""
            app="masters"
            entity="distributionchannel"
            options={[]}
            primary_key_field="channel_id"
            prefixId={true}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="sales_organization"
            id="sales_organization"
            required={true}
            disabled={false}
            label="Sales Organization"
            message="Select Sales Organization"
            placeholder="Select Sales Organization"
            validators=""
            app="masters"
            entity="salesorganization"
            options={[]}
            primary_key_field="sales_organization_id"
            prefixId={true}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="company_code"
            id="company_code"
            required={true}
            disabled={false}
            label="Company Code"
            message="Select Company Code"
            placeholder="Select Company Code"
            validators=""
            app="masters"
            entity="companycode"
            options={[]}
            primary_key_field="company_id"
            prefixId={true}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDTextBoxWrapper
            decorator="alias"
            id="alias"
            required={false}
            disabled={false}
            label="Alias"
            message="Enter alias"
            placeholder="Enter alias"
            validators=""
            maxlength={10}
            formRef={formRef}
          />
        </div>
      </div>
    );
  }
}

export default CustomerCodeRequest;
